import { areaState } from '@/app/model/store/domain/types.ts'

export default <areaState> {
  areaData: [],
  searchText: '',
  sortName: 'created_at',
  sortAsc: false
}
